import styled from 'styled-components';

export const UpcomingCardStyled = styled.div`
  .upcomingApp {
    padding: 0;
  }
  .upcomingcard {
    background: #ffffff;
    width: 350px;
    @media (max-width: 390px) {
      width: 334px;
    }
    @media (max-width: 375px) {
      width: 314px;
    }
    @media (max-width: 360px) {
      width: 308px;
    }
    height: 116px;
    cursor: pointer;
    border: 1px solid ${(props) => props.theme.royalBlue.borderGrey};
    border-radius: 8px;
    &.Shipment,
    &.pom{
      border: 1px solid rgba(185, 129, 28, 0.5) !important;
    }
    &.Prescription {
      border: 1px solid ${(props) => props.theme.green.borderGreen};
    }
    &.Appointment {
      border: 1px solid ${(props) => props.theme.blue.borderBlue};
    }
    &.HOME {
      border: 1px solid ${(props) => props.theme.royalBlue.borderGrey};
    }

    &.Flash {
      border: 1px solid ${(props) => props.theme.colors.accent.yellow["400"]};
    }

    &.Standard {
      border: 1px solid ${(props) => props.theme.colors.neutral.darkBlue['50']};
    }

    &.Express {
      border: 1px solid ${(props) => props.theme.colors.primary.green['400']};
    }

    .daytime {
      display: flex;
      justify-content: space-between;
      padding: 10px 12px;
      border-bottom: 1px solid ${(props) => props.theme.color.lightGray};
      align-items: center;

      .datetime {
        white-space: nowrap;
        flex-grow: 1;
        overflow: hidden;
        font-weight: 600;
        font-size: 13px;
        line-height: 16px;
        color: ${(props) => props.theme.text.dark};
        display: flex;

        .date {
          span {
            color: ${(props) => props.theme.grey.dark};
          }
        }

        .time {
          position: relative;
          padding: 0 0 0 22px;
          &::before {
            height: 6px;
            width: 6px;
            background-color: ${(props) => props.theme.color.border};
            border-radius: 6px;
            content: '';
            position: absolute;
            left: 8px;
            top: 5px;
          }
        }
      }

      .status {
        min-width: 100px;
        display: flex;
        justify-content: flex-end;
        .verification-status {
          overflow: hidden; 
          text-overflow: ellipsis; 
          white-space: nowrap;
          margin: 0px;
          padding: 3px 8px;
          height: 20px;
          font-size: 12px;
          line-height: 14px;
        }
      }
    }

    .upcomingdetail {
      display: flex;
      padding: 10px 12px;
      gap: 10px;
      .img {
        min-width: 60px;
        position: relative;

        .round {
          overflow: hidden;
          border-radius: 50% !important;
          min-width: 60px;
        }
        .bottomicon {
          position: absolute;
          bottom: 0px;
          right: 0px;
          div:first-child {
            border: 1px solid ${(props) => props.theme.color.white};
            border-radius: 50% !important;
          }
        }
      }
      .info {
        flex-grow: 1;
        display: flex;
        flex-direction: column;
        justify-content: center;
        max-width: calc(100% - 134px);
        overflow: hidden;

        .subtitle {
          font-weight: 600;
          font-size: 12px;
          line-height: 15px;
          color: ${(props) => props.theme.text.medium};
          width: 100%;
          display: flex;
          gap: 6px;
          margin-bottom: 2px;

          > div {
            text-overflow: ellipsis;
            width: 100%;
            overflow: hidden;
            white-space: nowrap;
            @media (max-width: 390px) {
            width: 50%;
          }
            @media (max-width: 360px) {
            width: 60%;
          }
          }
        }

        .title {
          font-weight: 700;
          font-size: 14px;
          line-height: 18px;
          color: ${(props) => props.theme.text.dark};
          text-overflow: ellipsis;
          margin-bottom: 4px;
          width: 100%;
          overflow: hidden;
          white-space: nowrap;
        }

        .patient {
          font-weight: 600;
          font-size: 13px;
          line-height: 16px;
          color: ${(props) => props.theme.royalBlue.DarkBlueGray};
          text-overflow: ellipsis;
          max-width: 100%;
          white-space: nowrap;
          overflow: hidden;

          span {
            color: ${(props) => props.theme.grey.dark};
          }
        }
      }

      .more {
        min-width: 54px;
        font-weight: 600;
        font-size: 13px;
        line-height: 16px;
        color: ${(props) => props.theme.grey.dark};
        margin-bottom: 2px;
        margin-top: 27px;

        &.HOME {
          margin-top: 14px;
          font-size: 14px;
        }
      }
    }
  }
`;
